import { router } from "@inertiajs/react"

import { Button } from "@/components/ui/button"
import { Panel } from "@/components/ui/panel"
import { adminSchoolTuningPath } from "@/routes"

import { TuneModal } from "../../call-lists/_components/tune-modal"
import type { ScopeOption, Tuning } from "../../call-lists/types"

/** The tunes in force on this school, each undoable, and the way to add one. */
export function TuningsPanel({
  schoolId,
  schoolName,
  scopeId,
  scopes,
  defaultScopeId,
  tunings,
}: {
  schoolId: number
  schoolName: string
  scopeId: number | null
  scopes: ScopeOption[]
  defaultScopeId: number | null
  tunings: Tuning[]
}) {
  return (
    <Panel
      title="Tuning"
      description="This school's place on every coordinator's list. Marking the booking contact, do-not-call and staff changes write to Salesforce and arrive with Phase 4."
      trailing={
        <TuneModal
          schoolId={schoolId}
          schoolName={schoolName}
          scopeId={scopeId}
          scopes={scopes}
          defaultScopeId={defaultScopeId}
        />
      }
    >
      {tunings.length === 0 ? (
        <p className="text-tertiary text-sm">Nothing tuned.</p>
      ) : (
        <ul className="divide-secondary flex flex-col divide-y">
          {tunings.map((t) => (
            <li
              key={t.id}
              className="flex items-center justify-between gap-3 py-2"
            >
              <div className="flex flex-col">
                <span className="text-primary text-sm font-medium">
                  {t.kind.replace(/_/g, " ")}
                  {t.until ? ` until ${t.until}` : ""}
                </span>
                <span className="text-tertiary text-xs">
                  {t.reason ?? t.value ?? ""}
                  {t.by ? ` · ${t.by}` : ""}
                </span>
              </div>
              <Button
                size="sm"
                color="tertiary"
                onPress={() =>
                  router.delete(adminSchoolTuningPath(schoolId, t.id), {
                    preserveScroll: true,
                  })
                }
              >
                Undo
              </Button>
            </li>
          ))}
        </ul>
      )}
    </Panel>
  )
}
